import React,{useEffect, useState} from "react";
import "./About.css";
import { CSSTransition } from 'react-transition-group'
import residency from '../../assets/rhl-ogidi2.jpg'
import AOS from "aos";
import hotelplace from '../../assets/hotelplace.webp';
import "aos/dist/aos.css";


const About = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  useEffect(() => {
    AOS.init({ duration: 2000 });
  }, []);


  return (
    <div>
      <section className="hero ">
        <div className="container parentHero hero2">
          <div className="row">
            <div className="col-md-5 imag">   
              <img
                src="https://images.unsplash.com/photo-1584132915807-fd1f5fbc078f?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80"
                alt="reside"
                onError={(e) => (e.target.src = hotelplace)}
              />
              <img
                src={residency}
                alt="residenc"
                className="secondImg"
              />
            </div>
            <div
              className="col-md-7 "
              style={{ width: "50%", marginLeft: "13%" }}
              data-aos="zoom-in"
            >
              <div className="copy copy2" >
                <div className="text-label">
                  RAISING COMFORT TO THE HIGHEST LEVEL
                </div>
                <div className="text-hero-bold">
                  Welcome to Residency Hotels
                </div>
                <div className="text-hero-regular">
                  Residency Hotels is a hotel chain in Nigeria with over 10
                  branches. The hotels offer a variety of amenities, including
                  air-conditioned rooms, private bathrooms, free Wi-Fi, swimming
                  pools, and restaurants. The hotels are located in major cities
                  across Nigeria, including Abuja, Lagos, and Enugu
                </div>
                <div className="text-hero-regular">
                  Residency Hotels are a popular choice for business travelers
                  and tourists alike. The hotels offer comfortable
                  accommodations and convenient amenities, making them a great
                  place to stay for a business trip or a vacation.
                  <p></p>
                  <p>Some of the features of Residency Hotels include:</p>
                </div>
    
                <div className="text-hero-regular">
                  {
                      isExpanded ? 
                      <CSSTransition
                      in={isExpanded}
                      timeout={300} // Adjust the animation duration as needed
                      classNames={{
                        enter: 'fade-enter',
                        enterActive: 'fade-enter-active',
                        exit: 'fade-exit',
                        exitActive: 'fade-exit-active',
                      }}
                      unmountOnExit
                      >
                        <>
                      <ul>
                      <li>Air-conditioned rooms</li>
                      <li>Private bathrooms</li>
                      <li>Free Wi-Fi</li>
                      <li>Swimming pools</li>
                      <li>Restaurants</li>
                      <li>Business centers</li>
                      <li>Fitness centers</li>
                      <li>24-hour front desk</li>
                      <li>Event Center</li>
                       {/* <li>Air-conditioned rooms</li>
                      <li>Air-conditioned rooms</li>  */}
                  </ul>
                  <p>Residency Hotels Limited is a popular choice for business travelers, tourists, and families. you can also host your seminar, lecture aswell as wedding ceremonies at Residency Event Hall</p>
                  </>
                      </CSSTransition>
                      : null
                  }
               
                </div>
                <div className="cta">
                  <button onClick={toggleExpand} className="btn btn-primary shadow-none ms-3">
                    {" "}
                    {isExpanded ? 'Less Details' : 'More Details'}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
